import {Tooltip} from 'platform/components';

import {useMemo} from 'react';

import {isNotNil} from 'ramda-adjunct';

import {useTextFieldContext} from './hooks/useTextFieldContext';
import {AdornmentWrapperButton, HelpIconWrapper} from './styles';
import {AdornmentOption} from './types';

interface AdornmentComponentProps extends Omit<AdornmentOption, 'key'> {
  inputName?: string;
}

const AdornmentComponent = ({
  name = 'endAdornment',
  disabled,
  inputName,
  Icon,
  render,
  disableFocusToInput,
  disableFocus,
  padless,
  onClick,
  tooltipText,
}: AdornmentComponentProps) => {
  const {disabled: inputDisabled, focusInput} = useTextFieldContext();

  const isDisabled = disabled ?? inputDisabled;

  const commonProps = useMemo(
    () => ({
      'data-testid': `text-field-${inputName}-adornment-${name}`,
      disabled: isDisabled,
      padless,
      disabledFocus: disableFocus,
      tabIndex: disableFocus || isDisabled ? -1 : 0,
      onClick: () => {
        if (!disableFocusToInput) {
          focusInput();
        }

        onClick?.();
      },
      className: 'text-field-adornment',
    }),
    [disableFocusToInput, onClick, isDisabled, padless, disableFocus, focusInput, name, inputName]
  );

  const finalRender = useMemo(() => {
    if (isNotNil(render)) {
      return render;
    }

    if (isNotNil(Icon)) {
      return <HelpIconWrapper inherit>{Icon}</HelpIconWrapper>;
    }

    return null;
  }, [render, Icon]);

  return (
    <Tooltip label={tooltipText || ''}>
      <AdornmentWrapperButton type="button" {...commonProps}>
        {finalRender}
      </AdornmentWrapperButton>
    </Tooltip>
  );
};

export const Adornment = AdornmentComponent;
